import React, { useState, useEffect } from "react";
import { createContainer } from "unstated-next";
import classNames from "classnames";
import { useScreenSize } from "./useScreenSize";

/**
 * Manages the expanded and open state of the Webapp UI
 */
function useWebUi(
  initialState = {
    expanded: true,
    open: false
  }
) {
  let [expanded, setExpanded] = useState(initialState.expanded);
  let [open, setOpen] = useState(initialState.open);
  let screenSize = useScreenSize();
  useEffect(() => {
    if (screenSize === "medium") {
      setExpanded(false);
    } else {
      setExpanded(true);
    }
  }, [screenSize]);
  return { expanded, open, setExpanded, setOpen };
}

/**
 * Unstated container that holds the UI State
 */
export let WebAppContext = createContainer(useWebUi);

const InnerWebAppContainer: React.FC<{}> = ({ children }) => {
  let state = WebAppContext.useContainer();
  return (
    <div
      className={classNames("wa-grid-container wa-sidenav-mobile", {
        "wa-sidenav-collapsed": !state.expanded
      })}
      id="waGridContainer"
      data-collapse={!state.expanded}
    >
      {children}
    </div>
  );
};

export const WAContainer: React.FC<{}> = ({ children }) => (
  <WebAppContext.Provider>
    <InnerWebAppContainer>{children}</InnerWebAppContainer>
  </WebAppContext.Provider>
);
